export default {
  version: '1.0812.1213',
  uploadUrl:'/admin/upload',//文件上传的url
}
